module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.allChannels), function(salesChannel) {
    return _c('div', {
      staticClass: "col-sm-12"
    }, [_c('div', {
      staticClass: "d-flex align-items-center justify-content-between"
    }, [_c('div', {}, [_c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('checkbox', {
      staticClass: "mt-1",
      on: {
        "input": function($event) {
          return _vm.salesChannelStateChanged(salesChannel)
        }
      },
      model: {
        value: (salesChannel.isActive),
        callback: function($$v) {
          _vm.$set(salesChannel, "isActive", $$v)
        },
        expression: "salesChannel.isActive"
      }
    }, [_vm._v("\n                        " + _vm._s(salesChannel.channelName) + "\n                    ")]), _vm._v(" "), (salesChannel.channelType == 50) ? _c('div', {
      staticClass: "ml-2"
    }, [_c('v-select', {
      attrs: {
        "options": _vm.agentsChannelOptions,
        "disabled": !salesChannel.isActive
      },
      on: {
        "input": function($event) {
          return _vm.agentsChannelOptionsChanged($event, salesChannel)
        }
      },
      model: {
        value: (_vm.selectedAgentsChannelOptions),
        callback: function($$v) {
          _vm.selectedAgentsChannelOptions = $$v
        },
        expression: "selectedAgentsChannelOptions"
      }
    })], 1) : _vm._e()], 1), _vm._v(" "), (salesChannel.channelType == 50) ? _c('div', [(_vm.customAgentSelction) ? _c('div', {
      staticClass: "d-flex flex-column pRelative ml-4"
    }, [_c('agent-white-list', {
      staticClass: "mt-2",
      attrs: {
        "allowedIdArray": _vm.scheduleTask.agentIdList,
        "startAllSelected": _vm.customAgentListSelectAll
      },
      on: {
        "input": _vm.agentListChanged
      }
    })], 1) : _vm._e()]) : _vm._e()])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 mt-4"
  }, [_c('h5', [_vm._v("Delivery")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('checkbox', {
    staticClass: "mt-1",
    model: {
      value: (_vm.scheduleTask.isToDeliverDocumentToEachEntity),
      callback: function($$v) {
        _vm.$set(_vm.scheduleTask, "isToDeliverDocumentToEachEntity", $$v)
      },
      expression: "scheduleTask.isToDeliverDocumentToEachEntity"
    }
  }, [_vm._v("\n                    Send report + invoice to each agent / OTA\n                ")])], 1)])])], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-048c040b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-048c040b"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/scheduleTasks/components/typeSpecific/formPartInvoice.vue
// module id = 1308
// module chunks = 0